import templateAdmin from '../../../../../Template/config/components/adminView'

export default {
    ...templateAdmin
}


// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/config/components/adminView/index.js